import React, { useState } from 'react';
import { MouseEvent } from 'react';
import { useSettings } from '../../contexts/SettingsContext';
import { SETTING_KEYS, LAB_TOKEN } from '../../constants';
import FullscreenToggle from '../FullscreenToggle';

import {
  AppBar,
  Box,
  IconButton,
  Toolbar,
  Typography,
  useTheme,
  Menu,
  MenuItem,
  Divider,
} from '@mui/material';

import {
  AccountCircle,
  Logout
} from "@mui/icons-material";

import { useNavigate } from "react-router-dom";

import MenuIcon from '@mui/icons-material/Menu';
import NotificationsIcon from '@mui/icons-material/Notifications';
type AdminNavBarProps = {
  toggleDrawer: () => void;
};
export default function AdminNavBar({ toggleDrawer }: AdminNavBarProps) {
  const { settings } = useSettings();
  const getSettingValue = (key: string): string | null => {
    const setting = settings?.find((s) => s.key === key);
    return setting?.value || null;
  };

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const theme = useTheme();

  const navigate = useNavigate();

  const handleMenuOpen = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget as HTMLElement);
  }
  const handleMenuClose = () => setAnchorEl(null);
  const handleLogout = () => {
    localStorage.removeItem(LAB_TOKEN);
    navigate("/");
  };

  return (
    <AppBar
      position="fixed"
      sx={{
        zIndex: theme.zIndex.drawer + 1,
        backgroundColor: '#00336C',
        height: 54, // Set your desired height in px
        justifyContent: 'center', // Vertically center the content
        px: 2,
      }}
    >
      <Toolbar disableGutters>
        <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', justifyContent: 'space-between' }}>

          {/* Left side */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <IconButton
              color="inherit"
              edge="start"
              onClick={toggleDrawer}
              sx={{ mr: 2 }}
            >
              <MenuIcon />
            </IconButton>
            {getSettingValue(SETTING_KEYS.SITE_LOGO) ? (
              <Box
                component="img"
                src={getSettingValue(SETTING_KEYS.SITE_LOGO) || 'Dashboard'}
                alt="Site Logo"
                sx={{
                  width: 150,
                  height: 48,
                  borderRadius: 2,
                  objectFit: 'cover',
                }}
              />
            ) : (
              <Typography 
                variant="h6" 
                sx={{ 
                  cursor: 'pointer', 
                  fontFamily: "'Lobster', cursive", 
                  fontWeight: 700,
                  letterSpacing: '0.1em',
                  textTransform: 'uppercase', 
                }}
                onClick={() => navigate('/dashboard')}>
                {getSettingValue(SETTING_KEYS.SITE_NAME) || 'DASHBOARD'}
              </Typography>
            )}
          </Box>

          {/* Right side */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {/*}
            <IconButton color="inherit">
              <NotificationsIcon />
            </IconButton>
            {*/}
            <FullscreenToggle />
            <IconButton color="inherit" onClick={handleMenuOpen}>
              <AccountCircle />
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
              PaperProps={{
                sx: {
                  overflow: "visible",
                  mt: 1.5, // margin top to give space for the arrow
                  width: 180,
                  "&::before": {
                    content: '""',
                    display: "block",
                    position: "absolute",
                    top: 0,
                    right: 30, // position horizontally relative to menu left edge
                    width: 10,
                    height: 10,
                    bgcolor: "background.paper",
                    transform: "translateY(-50%) rotate(45deg)",
                    zIndex: 0,
                    boxShadow:"rgba(0, 0, 0, 0.1) -1px -1px 1px 0px",
                  },
                },
              }}
            >
              <MenuItem onClick={() => navigate('/lab-profile')}>
                <AccountCircle fontSize="small" sx={{ mr: 1 }} /> Profile
              </MenuItem>
              <Divider />
              <MenuItem onClick={handleLogout}>
                <Logout fontSize="small" sx={{ mr: 1 }} /> Logout
              </MenuItem>
            </Menu>
          </Box>

        </Box>
      </Toolbar>
    </AppBar>
  );
}
